import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import React, {
  FunctionComponent,
  useContext,
  useEffect,
  useState,
} from 'react';
import {
  getDepartmentByMunicipality,
  getDepartmentName,
  getMunicipalityName,
  getTouristServiceTypeMuncipalityID,
  splitField,
  splitFieldForms,
} from '../../../shared/utils';
import serviceDetailBaseStyles from '../../../styles/atoms/service-detail-base.module.scss';
import { GeneralConfigContext } from '../../general-config-provider';
import LocationFormField from '../location-form-field';

type TouristPackagePreviewProps = {
  detailData: any;
};

export const TouristPackagePreview: FunctionComponent<
  TouristPackagePreviewProps
> = ({ detailData }) => {
  const router = useRouter();
  const t = useTranslations('viewOffer');
  const [locale, setLocale] = useState(router?.locale);
  const { generalConfig } = useContext(GeneralConfigContext);

  useEffect(() => {
    if (router.locale) {
      setLocale(router?.locale);
    }
  }, [router?.locale]);

  const getHours = (value) => {
    let text = '';
    switch (value) {
      case 1:
        text = t('duration.hour');
        break;
      case 2:
        text = t('duration.dias');
        break;
      case 3:
        text = t('duration.semana');
        break;
      case 4:
        text = t('duration.meses');
        break;
      default:
        break;
    }
    return text;
  };
  return (
    <div className={serviceDetailBaseStyles.detailContainer}>
      <div className={serviceDetailBaseStyles.field}>
        <p>
          Ubicación del paquete turístico:{' '}
          {
            <>
              {getDepartmentName(
                getDepartmentByMunicipality(
                  detailData?.ubicacion?.id_municipio,
                  generalConfig?.ciudad,
                  generalConfig?.departamento
                )?.id_departamento,
                generalConfig?.departamento
              )}
              ,{' '}
              {getMunicipalityName(
                detailData?.ubicacion?.id_municipio,
                generalConfig?.ciudad
              )}
            </>
          }
        </p>
      </div>
      <div className={serviceDetailBaseStyles.field}>
        <p>{t('duracion')}</p>
        <p>
          {detailData?.horas} {getHours(detailData?.tipo_hora)}
        </p>
      </div>
      {splitField(detailData?.itinerario, locale) != '' && (
        <div className={serviceDetailBaseStyles.field}>
          <p>{t('iterinario')}</p>
          <p>{splitField(detailData?.itinerario, locale)}</p>
        </div>
      )}

      {splitField(detailData?.no_incluye, locale) != '' && (
        <div className={serviceDetailBaseStyles.field}>
          <p>{t('noIncluye')}</p>
          <p>{splitField(detailData?.no_incluye, locale)}</p>
        </div>
      )}
      {splitField(detailData?.recomendaciones, locale) != '' && (
        <div className={serviceDetailBaseStyles.field}>
          <p>{t('recomendaciones')}</p>
          <p>{splitField(detailData?.recomendaciones, locale)}</p>
        </div>
      )}

      {splitField(detailData?.condiciones_informacion_adicional, locale) !=
        '' && (
        <div className={serviceDetailBaseStyles.field}>
          <p>{t('condicionesInformacion')}</p>
          <p>
            {splitField(detailData?.condiciones_informacion_adicional, locale)}
          </p>
        </div>
      )}
    </div>
  );
};
